/* tslint:disable */
import {
  Player,
  KanvasUser
} from '../index';

declare var Object: any;
export interface PlayerSerialInterface {
  "id": string;
  "serial"?: string;
  "hardwareHash"?: string;
  "transferable": boolean;
  "reassignable": boolean;
  "allowedHardware"?: string;
  "kanvasUserId"?: string;
  "parentContributorId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  player?: Player;
  kanvasUser?: KanvasUser;
  parentContributor?: KanvasUser;
}

export class PlayerSerial implements PlayerSerialInterface {
  "id": string;
  "serial": string;
  "hardwareHash": string;
  "transferable": boolean;
  "reassignable": boolean;
  "allowedHardware": string;
  "kanvasUserId": string;
  "parentContributorId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  player: Player;
  kanvasUser: KanvasUser;
  parentContributor: KanvasUser;
  constructor(data?: PlayerSerialInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerSerial`.
   */
  public static getModelName() {
    return "PlayerSerial";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerSerial for dynamic purposes.
  **/
  public static factory(data: PlayerSerialInterface): PlayerSerial{
    return new PlayerSerial(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerSerial',
      plural: 'PlayerSerials',
      path: 'PlayerSerials',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "serial": {
          name: 'serial',
          type: 'string'
        },
        "hardwareHash": {
          name: 'hardwareHash',
          type: 'string'
        },
        "transferable": {
          name: 'transferable',
          type: 'boolean',
          default: false
        },
        "reassignable": {
          name: 'reassignable',
          type: 'boolean',
          default: true
        },
        "allowedHardware": {
          name: 'allowedHardware',
          type: 'string',
          default: ''
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "parentContributorId": {
          name: 'parentContributorId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'playerSerialId'
        },
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        parentContributor: {
          name: 'parentContributor',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentContributorId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/PlayerSerial.ts